
import { Component, Prop, Vue } from 'vue-property-decorator'
import Mixin from './../helpers/mixin'

@Component({
  template: `
  <a class='download flex' :href='href' target='_blank' :download='getOriginalFilename()'>
    <img v-if='imageUrl' class='thumbnail' :src='imageUrl + "?width=67&height=67&mode=Min&format=webp"' :alt='title'>
    <div v-else class='default-image'></div>
    <div class='right flex flex-align-center flex-justify-between flex-grow-1'>
      <div class='text flex flex-column'>
        <div class='title ellipsis gray3--text'>{{ title }}</div>
        <div class='extension'>{{ type }}</div>
      </div>
      <i class='icons8-down'></i>
    </div>
  </a>
   `
})
export default class DownloadItem extends Mixin {
  @Prop() title!: string
  @Prop( { default: '' } ) href: string
  @Prop( { default: '' } ) imageUrl: string
  @Prop( { default: '' } ) originalFilename: string
  @Prop( { default: 'PDF' } ) type: string


  getOriginalFilename(): string {
    return this.originalFilename ?? '';
  }
}

